import { Invoice } from "../../../buy/services/invoice.model";
import ActionDispatcherService from "../../../common/actions/core/action-dispatcher.service";
import { NoAuthBillInfoEditDialogAction } from "../bill-info-edit/bill-info-edit-dialog.action";

export default class NoAuthBillInfoController {
  private invoice: Invoice;

  public maskedIdentityNo: string;

  constructor(
    private actionDispatcher: ActionDispatcherService
  ) { }

  public $onInit() {
    if (angular.isUndefined(this.invoice)) {
      return;
    }

    this.maskedIdentityNo = this.invoice.identityNo.replace(
      /(\d{3})(\d{5})(\d{3})/,
      '$1*****$3'
    );
  }

  public onEdit() {
    this.actionDispatcher.dispatch(new NoAuthBillInfoEditDialogAction(this.invoice));
  }

  public onNext() { }
}



// WEBPACK FOOTER //
// src/app/no-auth/components/bill-info/bill-info.controller.ts